"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageService = void 0;
var inversify_1 = require("inversify");
var StorageService = /** @class */ (function () {
    function StorageService() {
        this.ready = false;
    }
    StorageService.prototype.getKeyPrefix = function (config) {
        return "".concat(config.name, "_").concat(config.storeName || "localstore");
    };
    StorageService.prototype.resolveKey = function (key) {
        var keyPrefix = this.dbInfo.keyPrefix;
        if (!key) {
            return keyPrefix;
        }
        return "".concat(keyPrefix, "_").concat(key);
    };
    StorageService.prototype.checkIfStorageThrows = function () {
        var storageTestKey = "_al_storage_support_test";
        try {
            this.storage.setItem(storageTestKey, "true");
            this.storage.removeItem(storageTestKey);
            return false;
        }
        catch (e) {
            return true;
        }
    };
    StorageService.prototype.isStorageUsable = function () {
        return !this.checkIfStorageThrows() || this.storage.length > 0;
    };
    StorageService.prototype.callWhenReady = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.ready) {
                resolve(true);
            }
            else {
                reject(false);
            }
        });
    };
    StorageService.prototype.handleNotReady = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // eslint-disable-next-line no-console
                console.log(new Error("storage service not ready"));
                return [2 /*return*/];
            });
        });
    };
    StorageService.prototype.setStorage = function () {
        var driver = this.dbInfo.driver;
        switch (driver) {
            case "localstorage":
                this.storage = window.localStorage;
                break;
            case "sessionStorage":
                this.storage = window.sessionStorage;
                break;
            default:
                this.storage = window.localStorage;
                break;
        }
        return this.storage;
    };
    StorageService.prototype.init = function (config) {
        this.dbInfo = {
            name: config.name || "aku",
            storeName: config.storeName || "localstore",
            keyPrefix: this.getKeyPrefix(config),
            driver: config.driver || "localstorage",
        };
        this.setStorage();
        if (this.isStorageUsable()) {
            this.ready = true;
        }
    };
    StorageService.prototype.getItem = function (key) {
        var _this = this;
        return this.callWhenReady()
            .then(function () {
            var value = _this.storage.getItem(_this.resolveKey(key));
            if (value) {
                try {
                    return JSON.parse(value);
                }
                catch (error) {
                    return value;
                }
            }
            return value;
        })
            .catch(this.handleNotReady);
    };
    StorageService.prototype.setItem = function (key, value) {
        var _this = this;
        return this.callWhenReady()
            .then(function () {
            _this.storage.setItem(_this.resolveKey(key), value);
        })
            .catch(this.handleNotReady);
    };
    StorageService.prototype.removeItem = function (key) {
        var _this = this;
        return this.callWhenReady()
            .then(function () {
            _this.storage.removeItem(_this.resolveKey(key));
        })
            .catch(this.handleNotReady);
    };
    StorageService.prototype.clear = function () {
        var _this = this;
        return this.callWhenReady()
            .then(function () {
            var keyPrefix = _this.dbInfo.keyPrefix;
            for (var i = _this.storage.length - 1; i >= 0; i--) {
                var key = _this.storage.key(i);
                if ((key === null || key === void 0 ? void 0 : key.indexOf(keyPrefix)) === 0) {
                    _this.storage.removeItem(key);
                }
            }
        })
            .catch(this.handleNotReady);
    };
    StorageService.prototype.keys = function () {
        var _this = this;
        return this.callWhenReady()
            .then(function () {
            var dbInfo = _this.dbInfo;
            var length = _this.storage.length;
            var keys = [];
            for (var i = 0; i < length; i++) {
                var itemKey = _this.storage.key(i);
                if ((itemKey === null || itemKey === void 0 ? void 0 : itemKey.indexOf(dbInfo.keyPrefix)) === 0) {
                    keys.push(itemKey.substring(dbInfo.keyPrefix.length));
                }
            }
            return keys;
        })
            .catch(function () {
            _this.handleNotReady();
            return [];
        });
    };
    StorageService = __decorate([
        (0, inversify_1.injectable)()
    ], StorageService);
    return StorageService;
}());
exports.StorageService = StorageService;
